<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('videoUrl')" class="col-sm-4 col-form-label">Video URL</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('videoUrl')" v-model.lazy="videoUrl">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('userId')" class="col-sm-4 col-form-label">User ID (deprecated)</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('userId')" v-model.lazy="userId">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('videoId')" class="col-sm-4 col-form-label">Video ID (deprecated)</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('videoId')" v-model.lazy="videoId">
        </div>
      </div>

      <checkbox-input-group v-model="muted" label="Muted"
                            text="Play video without sound"></checkbox-input-group>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData } from '../../utils/index'

  export default {
    name: 'manager-video',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['videoUrl', 'userId', 'videoId', 'muted'])
    },
    created: function () {
      if (!this.userId) {
        this.userId = this.$keycloak.subject || 'a01eea58-fecc-468e-9f4e-13ef2873bf62' // Demo user account
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/manager-video.vue